class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    this.elements = {}
    this.onActionSummaryClick = this.handleActionSummaryToggle.bind(this);
  }

  cartDrawerRenderedUnsubscriber = undefined;

  connectedCallback() {
    this.initDetailsListeners();

    this.cartDrawerRenderedUnsubscriber = subscribe(PUB_SUB_EVENTS.cartDrawerRendered, (event) => {
      this.initDetailsListeners();
    });
  }

  disconnectedCallback() {
    if (this.cartDrawerRenderedUnsubscriber) {
      this.cartDrawerRenderedUnsubscriber();
    }
  }

  initDetailsListeners() {
    this.elements.drawerFooter = this.querySelector('.drawer__footer');
    this.elements.actions = this.querySelector('.cart-dawer__actions');
    this.elements.actionsDetails = this.querySelectorAll('.cart-dawer__actions > details');

    if (this.elements.actionsDetails.length > 0) {
      this.elements.actionsDetails.forEach((details) => {
        // Remove old listener if it exists to prevent doubles, then add new one
        details.removeEventListener('toggle', this.onActionSummaryClick);
        details.addEventListener('toggle', this.onActionSummaryClick);
      });
    }
  }

  handleActionSummaryToggle(event) {
    const hasOpenDetails = Array.from(this.elements.actionsDetails).some((details) => details.hasAttribute('open'));
    this.elements.actions.classList.toggle('cart-dawer__actions--open', hasOpenDetails);
    this.elements.drawerFooter.classList.toggle('drawer__footer--open', hasOpenDetails);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    publish(PUB_SUB_EVENTS.cartDrawer.open);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    publish(PUB_SUB_EVENTS.cartDrawer.close, {
      triggeredBy: this.activeElement,
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log('renderContents called with parsedState:');

    this.classList.remove('is-empty');
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.querySelector('.drawer__inner')?.scrollTo(0, 0);
    this.querySelector('.drawer__contents')?.scrollTo(0, 0);

    this.initDetailsListeners();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
